import * as React from 'react';
import { IGeneralDentalReferral } from '../../../../models/IGeneralDentalReferral';
import { AlertMessage, AlertType, Select, TextInput, Textarea } from 'soprasteria-ui-library';
import { useAuth } from '../../../../App';
import { CarePerformerApi } from '../../../../api/CarePerformerApi';
import { IListItem } from 'soprasteria-ui-library/dist/models/IFormInput';
import { setMessage } from '../../../../helpers/MessageHelper';
import { NoCarePerformersFoundMessage } from '../../../../utils/CarePerformerConstants';

interface IGeneralDentalReferralInformation {
    generalDentalReferral: IGeneralDentalReferral;
}

export const GeneralDentalReferralInformation: React.FunctionComponent<IGeneralDentalReferralInformation> = ({ generalDentalReferral }) => {
    const auth = useAuth();
    const carePerformerApi = new CarePerformerApi(auth);
    const [carePerformers, setCarePerformers] = React.useState<IListItem[]>([]);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [noCarePerformersMessage, setNoCarePerformersMessage] = React.useState<string>();

    React.useEffect(() => {
        if (generalDentalReferral.canWriteAnswer || generalDentalReferral.canCloseAsSysAdmin) {
            loadCarePerformerDentists();
        }
    }, [generalDentalReferral]);

    const loadCarePerformerDentists = () => {
        setIsLoading(true);
        carePerformerApi.getCarePerformerDentistsToday((carePerformers) => {
            let mappedCarePerformers = carePerformers.map<IListItem>((carePerformer) => { return { text: carePerformer.carePerformerName, value: carePerformer.carePerformerId.toString() } });
            setCarePerformers(mappedCarePerformers);
            if (mappedCarePerformers.length === 0) {
                const newMessage = setMessage(NoCarePerformersFoundMessage, noCarePerformersMessage ?? "");
                setNoCarePerformersMessage(newMessage);
            } else {
                setNoCarePerformersMessage("");
            }
        }, undefined, () => setIsLoading(false));
    }

    return (
        <>
            <AlertMessage alertType={AlertType.danger} duration={10000}>{noCarePerformersMessage}</AlertMessage>
            <div className="row readonly-less-margin">
                <h5 className="col-12">Remissinformation</h5>
                <div className="col-6">
                    <Textarea rows={6} name="generalDentalReferralReason" label="Remissorsak" defaultValue={generalDentalReferral.generalDentalReferralReason ?? ""} maxLength={100} required inlineLabel readonly={!generalDentalReferral.canEdit} />
                </div>
                <div className="col-6">
                    <Textarea rows={6} name="generalDentalReferralText" label="Remisstext" defaultValue={generalDentalReferral.generalDentalReferralText ?? ""} maxLength={8000} required inlineLabel readonly={!generalDentalReferral.canEdit} />
                </div>
                {
                    generalDentalReferral.generalDentalReferralAnswer || generalDentalReferral.canWriteAnswer || generalDentalReferral.canCloseAsSysAdmin ?
                        <>
                            <div className="col-6">
                                <Textarea rows={6} name="comment" label="Remissvar" defaultValue={generalDentalReferral.generalDentalReferralAnswer} maxLength={5000} required inlineLabel readonly={!(generalDentalReferral.canWriteAnswer || generalDentalReferral.canCloseAsSysAdmin)} />
                            </div>
                            <div className="col-6">
                                {
                                    generalDentalReferral.canWriteAnswer ?
                                        <Select name="recipientCarePerformer.carePerformerId"
                                            label="Behandlare"
                                            placeholder="Välj en behandlare"
                                            options={carePerformers}
                                            isLoading={isLoading}
                                            selectedValue={generalDentalReferral.recipientCarePerformer ? generalDentalReferral.recipientCarePerformer.carePerformerId.toString() : undefined}
                                            inlineLabel
                                            required />
                                        : <TextInput name="recipientCarePerformerReadonly"
                                            label="Behandlare"
                                            defaultValue={generalDentalReferral.recipientCarePerformer?.carePerformerName ?? ""}
                                            inlineLabel
                                            readonly />
                                }
                            </div>
                        </>
                        : null
                }
            </div >
            <hr />
        </>
    )
}